import React from "react";

interface ShimmerProps {
  className?: string;
  height?: string | number;
  width?: string | number;
}

/**
 * Generic Shimmer component for loading states
 * Creates a shimmering effect for content that is loading
 */
const Shimmer: React.FC<ShimmerProps> = ({
  className = "",
  height = "100%",
  width = "100%",
}) => {
  return (
    <div
      className={`animate-pulse bg-gradient-to-r from-gray-200 to-gray-200 dark:from-gray-700 dark:to-gray-800 rounded-md ${className}`}
      style={{
        height: typeof height === "number" ? `${height}px` : height,
        width: typeof width === "number" ? `${width}px` : width,
      }}
    />
  );
};

export default Shimmer;
